import { MouseEventHandler, ReactElement } from 'react';

import { Dot, Dots } from './PaginationDots.styles';

export const PaginationDots = (
    dots: ReactElement<{ children: ReactElement<{ onClick: MouseEventHandler<HTMLLIElement> }>; className: string }>[],
) => (
    <Dots>
        {dots.map((dot) => {
            const onClick = dot.props.children.props.onClick;
            const isActive = dot.props.className === 'slick-active';

            return <Dot key={dot.key} $isActive={isActive} onClick={onClick} data-active-dot={isActive || undefined} />;
        })}
    </Dots>
);
